<template>
  <form @submit.prevent="handleSubmit">
    <div class="login-control">
      <div class="login-control-icon">
        <i class="fal fa-user"></i>
      </div>
      <input
        type="text"
        name="initials"
        class="is-hidden-desktop login-input"
        placeholder="Initialer"
        v-model="initials"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{'is-invalid': submitted && errors.has('initials') }"
        @change="clearErrors"
        @focus="scrollToBottom()"
      />
      <input
        type="text"
        name="initials"
        class="is-hidden-touch login-input"
        placeholder="Initialer"
        v-model="initials"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{'is-invalid': submitted && errors.has('initials') }"
        @change="clearErrors"
      />
    </div>

    <div class="invalid-feedback" v-show="submitted && errors.has('initials')">
      {{ errors.first('initials') }}
    </div>

    <div class="login-control">
      <div class="login-control-icon">
        <i class="fal fa-lock"></i>
      </div>
      <input
        type="password"
        name="password"
        class="is-hidden-desktop login-input"
        placeholder="PIN"
        v-model="password"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{ 'is-invalid': submitted && !password }"
        @focus="scrollToBottom()"
      />
      <input
        type="password"
        name="password"
        class="is-hidden-touch login-input"
        placeholder="PIN"
        v-model="password"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{ 'is-invalid': submitted && !password }"
      />
      <router-link to="/forgot-password" class="login-forgot">Glömt PIN?</router-link>
    </div>

    <button type="submit" class="login-button" :disabled="status.loggingIn">
      <span v-if="!status.logginIn">Logga in</span>
      <span v-if="status.logginIn"><i class="fal fa-spinner-third fa-spin"></i> Loggar in</span>
    </button>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      initials: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('auth', ['status'])
  },
  methods: {
    ...mapActions('auth', ['login']),

    clearErrors () {
      this.$validator.reset()
    },
    scrollToBottom () {
      var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

      if (!iOS) {
        setTimeout(() => {
          window.scrollTo(0, 99999)
        }, 300)
      }
    },
    handleSubmit (e) {
      this.submitted = true
      const { initials, password } = this
      if (initials && password) {
        this.$store.state.loading = true
        this.login({ initials, password }).finally(() => {
          this.$store.state.loading = false
        })
      } else {
        this.$alert({
          title: 'Felaktig inloggning',
          text: 'Du måste fylla i både användarnamn och lösenord.',
          type: 'warning',
          confirmButtonText: 'Ok',
          allowOutsideClick: false
        })
      }
      /* this.login({ initials, password }).then(() => {
        setErrorsFromResponse(this)
      }) */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login/LoginPage.vue